import React, { Component } from 'react';
import Table, { ColumnProps } from 'antd/lib/table';
import umbrella from 'umbrella-storage';
import RequirementService, { RequirementListRequest, IRequirementInfo, IRequirementInfoList } from '../../service/requirement/RequirementService';
import './page-requirement.less';
import { timestamp2localdate } from '../../utils/dateTools';
import { DatePicker, Modal, Tooltip } from 'antd';
import RequeirementStatesSelect, { getRequirementStates } from '../../components/public/RequeirementStatesSelect';
import RequirementHistoryService from '../../service/requirement/RequirementHistoryService';
import moment from 'moment';
import RequirementHistoryTable from './RequirementHistoryTable';
import { getCompanyUrlParam } from '../../utils';
import { message } from 'antd';

interface RequirementTableProps {
    companyId: number | null;
    salesId: number | null;
    states: number[] | null;
    beginTime: string | null;
    endTime: string | null;
    isMyRequirementPage: boolean;
}

interface RequirementTableState {
    pageData: IRequirementInfoList | null;
    sourceData: IRequirementInfo[];
    salesSelectValue: number | null;
    beginTimeValue: string | null;
    endTimeValue: string | null;
    pagination: any;
    isUpdateStatesModalVisible: boolean; 
    isRequirementHistoryModalVisible: boolean; 
    selectedDate: moment.Moment | null;
    selectedStates : number | null;
    selectRequirementId: number | null;
}

//获取pageSize
const defaultPageSize = 5;
const getPageSize = () => {
    return umbrella.getLocalStorage('requirementPageSize') ? umbrella.getLocalStorage('requirementPageSize') : defaultPageSize;
}

const STORAGE_KEYS = {
    MY_REQUIREMENT_PAGE: 'myRequirementCurrentPage',
    REQUIREMENT_PAGE: 'requirementCurrentPage'
};

//自定义RequirementTable
class RequirementTable extends Component<RequirementTableProps, RequirementTableState> {
    state: RequirementTableState = {
        pageData: {
            records: [],
            total: 0,
            size: 0,
            current: 1,
            pages: 0
        },
        sourceData: [],
        beginTimeValue: null,
        endTimeValue: null,
        salesSelectValue: null,
        pagination: {
            current: parseInt(localStorage.getItem('requirementCurrentPage') || '1', 10),
            pageSize: getPageSize(),
            total: 0
        },
        isUpdateStatesModalVisible: false,
        isRequirementHistoryModalVisible: false,
        selectedDate: null,
        selectedStates: null,
        selectRequirementId: null,
    };

    async componentDidMount() {
        await this.getRequirementTableData(1, this.props.companyId);
    }

    async componentDidUpdate(prevProps: Readonly<RequirementTableProps>, prevState: Readonly<RequirementTableState>) {
        if (prevState.pagination && prevState.pagination.pageSize !== this.state.pagination.pageSize) {
            await this.getRequirementTableData(1);
        }
    }

    //定义表格的列属性
    columns: ColumnProps<any>[] = [
        {
            title: '渠道',
            width: 10,
            key: 'salesChannel',
            render: (record: IRequirementInfo) => {
                if (typeof record.sales !== 'number') {
                    return '';
                }
                return record.sales < 0 ? '外部' : '内部';
            },
        },
        { title: '销售', width: 20, dataIndex: 'salesName', key: 'salesName' },
        { title: '客户公司', width: 25, dataIndex: 'companyName', key: 'companyName' },
        { title: '需求名称', width: 30, dataIndex: 'name', key: 'name'},
        { 
            title: '需求简介', 
            width: 50, 
            dataIndex: 'introduction', 
            key: 'introduction',
            render: (text: string) => (
                <Tooltip 
                    title={<div style={{ whiteSpace: 'pre-wrap', maxWidth: '750px' }}>{text}</div>}
                    placement="topLeft"
                    overlayStyle={{ maxWidth: '750px' }}
                >
                    <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', maxHeight: '100px',
                        overflowY: 'auto', cursor: 'pointer'}}
                    >
                        {text}
                    </div>
                </Tooltip>
            )
        },
        { title: '需求状态', width: 20, dataIndex: 'states', key: 'states'},
        { title: '需求对接人', width: 20, dataIndex: 'customerName', key: 'customerName'},
        { title: '交付时间', width: 20, dataIndex: 'deliveryTime', key: 'deliveryTime'},
        { title: '需求预算', width: 15, dataIndex: 'budget', key: 'budget'},
        { title: '需求创建时间', width: 20, dataIndex: 'createTime', key: 'createTime'},
        { title: '最后更新时间', width: 20, dataIndex: 'lastEditTime', key: 'lastEditTime' },
        {
            title: '操作',
            key: 'operation',
            fixed: 'right',
            width: 38,
            render: (record: IRequirementInfo) => (
                <>
                    <button onClick={() => this.handleUpdateStatesBottonClick(record)}>更新状态</button>
                    <button onClick={() => this.handleHistoryInfoBottonClick(record)}>历史</button>
                    <button onClick={() => this.handleEditBottonClick(record)}>编辑</button>
                </>
            ),
        },
    ];
    
    // 允许外部组件手动重置分页
    setPaginationPage = (pageNo: number) => {
        this.setState({
            pagination: { ...this.state.pagination, current: pageNo }
        });
    };

    //获取指定页码的查询数据
    getRequirementTableData = async (pageNo:number, companyId?:number | null, salesId?:number | null,
                                     beginTimeValue?:string | null, endTimeValue?:string | null, statesSelectValue?:number[] | null) => {
        const request: RequirementListRequest = {
        requirementQueryParam: {
            companyId: companyId ?? this.props.companyId ?? undefined,
            salesId: salesId ?? this.props.salesId ?? undefined,
            states: statesSelectValue ?? this.props.states ?? undefined,
            beginTime: beginTimeValue ?? this.props.beginTime ?? undefined,
            endTime: endTimeValue ?? this.props.endTime ?? undefined,
        },
        pageNo,
        pageSize: this.state.pagination.pageSize,
        };

        try {
            const response = this.props.isMyRequirementPage ? await RequirementService.getRequirementByLoginAccount(request) :
                                       getCompanyUrlParam() ? await RequirementService.getRequirementByCompanyId(request) :
                                                              await RequirementService.getRequirementListInfo(request);
       
            if (response) {
                const pageData: IRequirementInfoList = response.data && response.data.requirementsInfoList ? response.data.requirementsInfoList : [];
                const RequirementRecords = pageData && pageData.records ? response.data.requirementsInfoList.records : [];
                const mappedSourceData: IRequirementInfo[] = RequirementRecords.map((item: any) => ({
                    id: item.id,
                    sales: Number(item.sales),
                    salesName: item.salesName,
                    customer: item.customer,
                    customerName: item.customerName,
                    companyName: item.companyName,
                    name: item.name,
                    introduction: item.introduction,
                    deliveryTime: timestamp2localdate(item.deliveryTime, false),
                    budget: item.budget,
                    createTime: timestamp2localdate(item.createTime, false),
                    lastEditTime: timestamp2localdate(item.lastEditTime, false),
                    states: getRequirementStates(item.states),
                }));
                this.setState({
                    pageData: { ...pageData, current: pageNo },
                    sourceData: mappedSourceData,
                    pagination: { ...this.state.pagination, total: pageData.total },
                });
            }
        } catch (error) {
            console.error('获取需求列表失败:', error);
        }
    };

    //页码切换事件
    handleChangePage = (pageNo: number) => {
        if (pageNo !== this.state.pagination.current) {
            // 根据页面类型选择对应的 storage key
            const storageKey = this.props.isMyRequirementPage 
                ? STORAGE_KEYS.MY_REQUIREMENT_PAGE 
                : STORAGE_KEYS.REQUIREMENT_PAGE;

            // 保存页码到对应的 storage key
            localStorage.setItem(storageKey, pageNo.toString());

            this.setState(
                (prevState) => ({
                    pagination: { ...prevState.pagination, current: pageNo },
                }),
                () => this.getRequirementTableData(pageNo, this.props.companyId, this.props.salesId, 
                                                   this.props.beginTime, this.props.endTime, this.props.states)
            );
        }
    };

    //PageSize选项卡事件
    changePageSize = (current: number, pageSize: number) => {
        umbrella.setLocalStorage('requirementPageSize', pageSize);
        localStorage.setItem(STORAGE_KEYS.MY_REQUIREMENT_PAGE , "1");
        localStorage.setItem(STORAGE_KEYS.REQUIREMENT_PAGE , "1");
        this.setState({
            pagination: { current: 1, pageSize, total: this.state.pagination.total }
        });
    };


    //编辑按钮事件
    handleEditBottonClick = (requirementData: IRequirementInfo) => {
        // 跳转需求管理页面
        const queryString = `?id=${requirementData.id}`; 
        window.location.href = '/#/app/customer/requirement/manager' + queryString;
    }

    //更新状态按钮事件
    handleUpdateStatesBottonClick = (requirementData: IRequirementInfo) => {
        this.setState({
            isUpdateStatesModalVisible: true,
            selectRequirementId: requirementData.id,
            selectedStates: null,
            selectedDate: null,
        });
    }
    //历史信息按钮事件
    handleHistoryInfoBottonClick = (requirementData: IRequirementInfo) => {
        this.setState({ isRequirementHistoryModalVisible: true , selectRequirementId: requirementData.id });
    }

    //更新状态确认按钮事件
    handleUpdateStatesOk = async () => {
        const { selectedStates, selectedDate, selectRequirementId, pagination } = this.state;
        if (typeof selectedStates !== 'number') {
            message.warning('请选择需求状态');
            return;
        }

        if (!selectedDate) {
            message.warning('请选择日期');
            return;
        }

        if (!selectRequirementId) {
            message.error('需求ID无效');
            return;
        }

        try {
            const response = await RequirementHistoryService.addRequirementHistory({
                requirementId: selectRequirementId,
                states: selectedStates,
                createTime: selectedDate.startOf('day').toDate().toISOString(),
            });

            if (response && response.success) {
                await this.getRequirementTableData(
                    pagination.current,
                    this.props.companyId,
                    this.props.salesId,
                    this.props.beginTime,
                    this.props.endTime,
                    this.props.states
                );
                this.setState({ isUpdateStatesModalVisible: false, selectedStates: null, selectedDate: null });
                message.success('需求状态更新成功');
            } else {
                message.error(response?.message || '需求状态更新失败');
            }
        } catch (error) {
            message.error('需求状态更新失败');
        }
    }

    //更新状态选择框事件
    handleStatesSelectChange = (value: any) => {
        this.setState({ selectedStates: value }); 
    }

    //更新状态日期选择框事件
    handleDateChange = (date) => {
        this.setState({ selectedDate: date });
    };

    // 禁止选择未来日期
    disableFutureDate = (current: moment.Moment) => {
        return !!current && current > moment().endOf('day');
    };

    render() {
        const { sourceData, pagination } = this.state;
        const dataWithKeys = sourceData.map((row) => ({ ...row, key: row.id }));
        const columnsToShow = this.props.companyId ? this.columns.filter(col => col.key !== 'companyName') : this.columns; //在客户需求页面隐藏公司名称

        return (
            <div style={{ width: '100%', overflow: 'auto' }}>
                <Table size="small"
                    columns={columnsToShow}
                    dataSource={dataWithKeys}
                    pagination={{
                        showSizeChanger: true,
                        current: pagination.current,
                        pageSize: pagination.pageSize,
                        total: pagination.total,
                        pageSizeOptions: ['5', '10', '20', '50', '100'],
                        showTotal: (total, range) => `显示第 ${range[0]} 到第 ${range[1]} 条记录，共 ${total} 条记录`,
                        onShowSizeChange: this.changePageSize,
                        onChange: this.handleChangePage,
                    }}
                    scroll={{ x: 1580, y: 360 }}
                />

                <Modal
                    title="更新状态"
                    className="updateStatesModal"
                    visible={this.state.isUpdateStatesModalVisible}
                    destroyOnClose
                    onOk={this.handleUpdateStatesOk}
                    onCancel={() => { this.setState({ isUpdateStatesModalVisible: false, selectedStates: null, selectedDate: null });}}
                >
                    <div>
                        <label style={{ marginRight: '8px' }}>需求状态:</label>
                        <RequeirementStatesSelect
                            showAllOption={false}
                            initialValues={this.state.selectedStates ?? undefined}
                            mode={undefined}
                            onChange={this.handleStatesSelectChange}
                        />
                    </div>

                    <div style={{ marginTop: '16px' }}>
                        <label style={{ marginRight: '41px' }}>日期:</label>
                        <DatePicker
                            value={this.state.selectedDate}
                            onChange={this.handleDateChange}
                            disabledDate={this.disableFutureDate}
                            style={{ width: '50%' }}
                        />
                    </div>
                </Modal>

                <Modal
                    title="需求历史状态信息"
                    className="requirementHistoryModal"
                    visible={this.state.isRequirementHistoryModalVisible}
                    okButtonProps={{ style: { display: 'none' } }}
                    cancelButtonProps={{ style: { display: 'none' } }}
                    onCancel={() => { this.setState({ isRequirementHistoryModalVisible: false }); }} 
                >
                    <div>
                        <RequirementHistoryTable
                            requirementId={this.state.selectRequirementId}
                        />
                    </div>
                </Modal>
                
            </div>
        );
    }

};

export default RequirementTable;
